<div>
  @if (purchaseId && tenantId) {
    <app-checkout
      [tenantId]="tenantId"
      [invoiceId]="purchaseId"
      [isDES]="true"
    ></app-checkout>
  } @else {
    <div class="text-error">
      <p>Unable to load checkout. Purchase is invalid.</p>
    </div>
  }
</div>
